import "../styles/genai.css";
import cloudHeroImg from "../assets/cloud-hero.png";

export default function CloudHero() {
  return (
    <section
      className="genai-hero full-hero"
      style={{
        backgroundImage: `url(${cloudHeroImg})`,
      }}
    >
      {/* OVERLAY */}
      <div className="hero-overlay"></div>

      {/* CONTENT */}
      <div className="hero-content">
        <h1 className="hero-title">
          CLOUD COMPUTING STARTER PROGRAM (AWS)
        </h1>

        <p className="hero-desc">
          Learn to Build, Deploy, and Manage Real-World Cloud Applications
        </p>

        
      </div>
    </section>
  );
}
